import React from 'react'
import { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import Swal from 'sweetalert2';

export default function Complayananrompi({ onUpdateTotal }) {
    const urlapi = process.env.REACT_APP_BASE_URL;
    const { kode_booking, kode_booking2 } = useParams();
    const [dataBookingRompi, setDataBookingRompi] = useState([]);
    const [show, setShow] = useState(false);
    const [valrompi, setValrompi] = useState('')
    const [rompi, setRompi] = useState([]);
    const [selectedLayanan, setSelectedLayanan] = useState([]);

    const getrompi = async () => {
        try {
            const response = await axios.get(urlapi + "Rompi");
            setRompi(response.data);
            // console.log(response.data);
        } catch (error) { }
    };

    const formatrupiah = (numb) => {
        const format = numb.toString().split("").reverse().join("");
        const convert = format.match(/\d{1,3}/g);
        const rupiah = "Rp " + convert.join(".").split("").reverse().join("");
        return rupiah;
    };

    const handlerompi = (e, id, harga) => {

        let allData = JSON.parse(localStorage.getItem('bookingData')) || [];

        if (e.target.checked) {
            // Tambah langsung meskipun idfoto sama sudah ada
            setValrompi(id)
            allData.push({
                idrompi: id.toString(),
                harga: harga.toString()
            });
        } else {
            // Hapus SATU data yang cocok (hanya satu kali)
            setValrompi('')
            const index = allData.findIndex(
                item => item.idrompi === id.toString() && item.harga === harga.toString()
            );
            if (index !== -1) {
                allData.splice(index, 1);
            }
        }

        localStorage.setItem('bookingData', JSON.stringify(allData));
        const data = JSON.parse(localStorage.getItem('bookingData')) || [];
        let total = data.reduce((sum, item) => {
            return sum + parseInt(item.harga);
        }, 0);

        console.log("Total Harga:", total);
        localStorage.setItem("totalHarga", total);

        onUpdateTotal();
    }

    const getDataBookingRompi = async () => {
        try {
            const response = await axios.get(urlapi + "BookingRompi?kode=" + kode_booking + "&&kode2=" + kode_booking2 + "&&iduser=" + localStorage.getItem('id'));

            setDataBookingRompi(response.data);

        } catch (error) {

        }
    }

    const handlehapusrompi = async (kode_booking, idrompi) => {

        Swal.fire({
            title: 'Apakah kamu yakin?',
            text: "Data yang dihapus tidak bisa dikembalikan!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ya, hapus!',
            cancelButtonText: 'Batal'
        }).then((result) => {
            if (result.isConfirmed) {

                hapusRompi(kode_booking, idrompi)
            }
        });
    }

    const hapusRompi = async (kode, idrompi) => {

        await axios.put(urlapi + "Layanan/" + kode + "/" + idrompi + '/rompi')
            .then((response) => {
                getrompi();
                getDataBookingRompi();
                Swal.fire(
                    'Terhapus!',
                    'Data berhasil dihapus.',
                    'success'
                );
            }).catch((err) => {

            });
    }

    useEffect(() => {
        getrompi();
        getDataBookingRompi();
    }, [])
    return (
        <div>
            <div className='card mt-1'>
                <div className='card-body'>

                    <div className='d-flex justify-content-between fw-bold mb-2' onClick={() => setShow(!show)}>
                        <small><i className='fas fa-shirt'></i> Rompi</small>
                        <small>{valrompi != '' ? <i className='fas fa-circle-check text-success'></i> : ''}{' '}<i className={show == false ? 'fas fa-angle-right' : 'fas fa-angle-down'}></i></small>
                    </div>
                    <div className={show == false ? 'd-none' : ''}>
                        {rompi.map((data, index) => {
                            return (
                                <div>
                                    <div className='d-flex justify-content-between' key={index}>
                                        <div>
                                            <small style={{ color: "#2b2e5a" }} className='fw-bold'>{data.rompi}</small>
                                            <div><span className='badge rounded-pill bg-success'>{formatrupiah(data.harga)}</span></div>
                                        </div>
                                        <div>
                                            <div class={dataBookingRompi.id == data.id ? 'form-check d-none' : 'form-check'}>
                                                <img
                                                    src={
                                                        "https://ratumerak.id/adminmmsc/assets/berkas/" +
                                                        data.foto
                                                    }
                                                    className="img-fluid"
                                                    alt="Responsive image"
                                                    style={{ height: "40px" }}
                                                ></img>
                                                <input
                                                    class="form-check-input  border border-danger"
                                                    type="checkbox"
                                                    name="foto"
                                                    id="foto"
                                                    onChange={(e) => handlerompi(e, data.id, data.harga)}
                                                />
                                            </div>

                                        </div>
                                    </div>
                                    {dataBookingRompi.id == data.id ? <div className='text-center text-danger mt-2'><i className='fas fa-warning'></i> Layanan rompi ini sudah anda booking <br /><button className={dataBookingRompi.status == '1' ? 'd-none' : 'btn btn-danger btn-sm'} onClick={() => handlehapusrompi(kode_booking, data.id)}> <i className='fas fa-trash'></i> Hapus</button></div> : ''}
                                    <hr />
                                </div>
                            )
                        })}
                    </div>
                </div>
            </div>
        </div>
    )
}
